


































































import { Vue, Component } from 'vue-property-decorator'
import { ActionTypes } from '@/store/modules/customer/types'

@Component
export default class MyPageCancellation extends Vue {
    showPopup = false
    hasPlan = false

    async created() {
        this.hasPlan = this.$store.state.customer.userdata == null ? false : true
    }

    async onCancelClicked(): Promise<void> {
        this.$store.commit(ActionTypes.START_PAYMENT)
        let isSuccess = await this.$store.dispatch(ActionTypes.CANCEL_PLAN_REQUEST)
        this.showPopup = false
        if (isSuccess) {
            this.$router.push('/feedback')
            await this.$store.dispatch(ActionTypes.GET_USERDATA)
            console.log()
            console.log(this.$store.state.customer.userdata)
        }
    }
}
